import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LoadingService } from "@app/core";
import { BillingPortalDialogComponent, BillingPortalDialogData } from "@app/shared/components";
import { ToastService } from "@app/shared/ui";
import { TranslocoService } from "@ngneat/transloco";
import { PaymentService } from "clearline-api";
import { finalize, take } from "rxjs/operators";

/**
 * Opens Billing & Invoices in an in-app dialog using a backend-issued Chargebee SSO session URL.
 */
@Injectable({ providedIn: "root" })
export class ChargebeePortalService {
  constructor(
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private paymentService: PaymentService,
    private toastService: ToastService,
    private transloco: TranslocoService
  ) {}

  openBillingPortal(): void {
    this.loadingService.showSpinner();

    this.paymentService
      .getChargebeeSsoSessionUrl()
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideSpinner())
      )
      .subscribe({
        next: ({ url }) => {
          if (!url) {
            this.showError();
            return;
          }

          this.dialog.open(BillingPortalDialogComponent, {
            data: { url } as BillingPortalDialogData,
            panelClass: "modal-billing-portal",
            width: "600px",
            maxWidth: "95vw",
            height: "760px",
            maxHeight: "90vh",
            autoFocus: false
          });
        },
        error: () => this.showError()
      });
  }

  private showError(): void {
    this.toastService.danger(this.transloco.translate("common.topBar.billingPortalError"));
  }
}
